<template>
  <div id="news">
    <div id="news-main">
      <div id="news-content">
        <p id="content-title">
          {{ imgSrc[activeIndex].title }}
        </p>
        <div id="content-swiper">
          <div id="swiper-box" ref="newsBox">
            <img
              class="swiper-box-img"
              ref="newsImg"
              v-for="(item, idx) of imgSrc"
              :key="idx"
              :src="item.img"
              @click.stop="showDetail(item)"
            />
          </div>
          <img
            ref="newsLeftBtn"
            id="news-left"
            src="../assets/images/news-left.png"
            @click.stop="nextFn"
          />
          <img
            ref="newsRightBtn"
            id="news-right"
            src="../assets/images/news-right.png"
            @click.stop="preFn"
          />
        </div>
        <div id="content-dot">
          <div
            :class="i == activeIndex + 1 ? 'dots active-dot' : 'dots'"
            v-for="i of imgSrc.length"
            :key="i"
            @click.stop="dotFn(i - 1)"
          ></div>
        </div>
        <ul id="content-list">
          <li
            class="list-li"
            v-for="(item, index) of newsData"
            :key="index"
            @click.stop="moreFn(item.url)"
          >
            <span class="list-title">{{ item.title }}</span>
            <span class="more"
              >{{ $t("news.more")
              }}<img class="more-image" src="../assets/images/more.png"
            /></span>
          </li>
        </ul>
      </div>
      <div id="detail" v-if="detailShow" @click.self="toggleNews(false)">
        <div id="detail-main">
          <img id="detail-img" src="../assets/images/news-detail-top.png" />
          <div id="detail-article">
            <p id="acticle-title" v-if="newsActive.title">{{ newsActive.title }}</p>
            <p id="acticle-date" v-if="newsActive.date">{{ newsActive.date }}</p>
            <p id="acticle-content" v-if="newsActive.content" v-html="newsActive.content"></p>
          </div>
        </div>
        <img
          id="close"
          src="../assets/images/close.png"
          @click.stop="toggleNews(false)"
        />
      </div>
      <Download />
    </div>
  </div>
</template>

<script>
import Download from "@/components/Download.vue";

export default {
  components: {
    Download,
  },
  data() {
    return {
      activeIndex: 0,
      newsActive: {},
      detailShow: false,
      imgSrc: this.$t('news.slider'),
      newsData: this.$t('news.url'),
    };
  },
  computed: {
    slider() {
      return this.$t('news.slider')
    },
    url() {
      return this.$t('news.url')
    },
  },
  watch: {
    slider: {
      handler(val) {
        this.imgSrc = val;
      },
      deep: true
    },
    url: {
      handler(val) {
        this.newsData = val;
      },
      deep: true
    }
  },
  methods: {
    preFn() {
      this.$refs.newsLeftBtn.style.cursor = "pointer";
      if (this.activeIndex == this.imgSrc.length - 1) {
        this.$refs.newsRightBtn.style.cursor = "not-allowed";
        return;
      }
      this.$refs.newsBox.style.left =
        "-" + this.$refs.newsImg[0].offsetWidth * (this.activeIndex + 1) + "px";
      this.activeIndex++;
    },
    nextFn() {
      this.$refs.newsRightBtn.style.cursor = "pointer";
      if (this.activeIndex == 0) {
        this.$refs.newsLeftBtn.style.cursor = "not-allowed";
        return;
      }
      this.$refs.newsBox.style.left =
        "-" + this.$refs.newsImg[0].offsetWidth * (this.activeIndex - 1) + "px";
      this.activeIndex--;
    },
    dotFn(i) {
      this.activeIndex = i;
      if (i == 0) {
        this.$refs.newsLeftBtn.style.cursor = "not-allowed";
      }
      if (this.activeIndex == this.imgSrc.length - 1) {
        this.$refs.newsRightBtn.style.cursor = "not-allowed";
      }
      this.$refs.newsBox.style.left =
        "-" + this.$refs.newsImg[0].offsetWidth * i + "px";
    },
    showDetail(item) {
      this.newsActive = JSON.parse(JSON.stringify(item));
      this.detailShow = true;
    },
    toggleNews(bol) {
      this.detailShow = bol;
    },
    moreFn(url){
      window.open(url, "_blank");
    }
  },
};
</script>

<style scoped lang="scss">
#news-main {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/news-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
  font-size: 14px; /*no*/
}
#news-content {
  width: 1453px;
  height: 660px;
  position: absolute;
  top: 175px;
  left: 280px;
  background-image: url("../assets/images/news-content-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
#content-title {
  width: 550px;
  position: absolute;
  left: 60px;
  top: 45px;
  font-weight: 600;
  font-size: 18px; /*no*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#content-swiper {
  width: 640px;
  height: 360px;
  position: absolute;
  left: 20px;
  top: 120px;
  z-index: 9;
  overflow: hidden;
}
#content-dot {
  position: absolute;
  bottom: 110px;
  left: 20px;
}
.dots {
  display: inline-block;
  width: 145px;
  height: 10px;
  margin-right: 5px;
  background: #fff;
  opacity: 0.5;
  cursor: pointer;
}
.active-dot {
  opacity: 1;
}
#swiper-box {
  width: 1920px;
  height: 360px;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s ease;
}
.swiper-box-img {
  width: 640px;
  height: 360px;
  cursor: pointer;
}
#news-left {
  width: 23px;
  height: 41px;
  position: absolute;
  left: 8px;
  top: 180px;
  z-index: 999;
  cursor: pointer;
}
#news-right {
  width: 23px;
  height: 41px;
  position: absolute;
  right: 15px;
  top: 180px;
  z-index: 999;
  cursor: pointer;
}
#content-list {
  position: absolute;
  // top: 84px;
  top: 124px;
  left: 680px;
}
.list-li {
  width: 540px;
  height: 68px;
  position: relative;
  margin-top: 4px;
  padding: 18px 20px 0 40px;
  cursor: pointer;
  background-image: url("../assets/images/li-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
.list-title {
  display: inline-block;
  width: 390px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.more {
  width: 125px;
  position: absolute;
  top: 22px;
  right: 0;
  color: #3b9ef9;
  vertical-align: middle;
  font-size: 12px; /*no*/
}
.more-image {
  width: 25px;
  height: 16px;
  vertical-align: middle;
}
#detail {
  width: 100%;
  height: calc(100% + 97px);
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 0;
  top: -97px;
  z-index: 999;
}
#detail-main {
  width: 828px;
  height: 800px;
  position: absolute;
  top: 80px;
  left: 50%;
  margin-left: -414px;
  z-index: 9999;
  background: #000;
}
#detail-img {
  width: 828px;
  height: 295px;
  display: block;
}
#detail-article {
  width: calc(100% - 134px);
  height: 445px;
  padding: 30px 67px;
  overflow-y: auto;
}
#acticle-title {
  text-align: center;
  font-size: 24px;
  font-weight: 800;
}
#acticle-date {
  margin-top: 15px;
  text-align: center;
  font-size: 16px;
  color: #808184;
}
#acticle-content {
  margin-top: 25px;
  font-size: 18px;
  color: #efeeee;
  
}
#acticle-content>p{
  display: block;
  margin-bottom: 10px;
}
#close {
  width: 39px;
  height: 39px;
  position: absolute;
  top: 80px;
  right: 430px;
  z-index: 9999;
  cursor: pointer;
}
</style>
